module.exports = "<article style=\"margin:0 auto\" max-width=\"lg\">\r\n  <header>\r\n    <div class=\"kd-item kd-item--large padding-md margin-md\">\r\n      <h1 class=\"typo-display-1 nobreak flex\">{{::$ctrl.data.Nombre}}</h1>\r\n    </div>\r\n  </header>\r\n  <div ui-view></div>\r\n</article>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/contabilidad/clientescuentascontables/components/detalle/template.html
// module id = 1766
// module chunks = 0